import React from 'react';

const Info = props => <div className="ifdw-infobox-info">{props['info.content']}</div>;

export default Info;



// WEBPACK FOOTER //
// ./src/components/Infobox/info.js